import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

const propTypes = {
	currentPageTitle: PropTypes.string,

	// The browser history object (provided by react router)
	history: PropTypes.object.isRequired,

};

const defaultProps = {
	currentPageTitle: "Temporary Technical Difficulties",
};

// Props connected to the store
const mapStateToProps = (state) => {
	return {
		errorMessage: state.errorMessage,
	};
};

class WebserviceDown extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

	}

	render() {
		return (
			<React.Fragment>
				<h1>{this.props.currentPageTitle ? this.props.currentPageTitle: '\u00a0'}</h1>
				<div className="content fr-view">
					<p>COBI is undergoing scheduled maintenance</p>
					<p>If issue persists please contact Legislative Services</p>
					<p className="withBottomPadding">{this.props.errorMessage}</p>
				</div>
			</React.Fragment>
		);
	}
}

WebserviceDown.propTypes = propTypes;
WebserviceDown.defaultProps = defaultProps;

export default connect(mapStateToProps)(WebserviceDown);